(() => {
  if (window.BHDecorations) return;

  const NS = 'http://www.w3.org/2000/svg';

  const drawings = {
    star:
      '<path d="M50 5 63 34 95 38 71 60 77 93 50 77 23 93 29 60 5 38 37 34Z"/>',

    sun:
      '<circle cx="50" cy="50" r="19"/>' +
      '<path d="M50 5V17M50 83V95M5 50H17M83 50H95M18 18L27 27M73 73L82 82M18 82L27 73M73 27L82 18" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>',

    sparkle:
      '<path d="M50 3C47 34 35 47 3 50C35 53 47 66 50 97C53 66 65 53 97 50C65 47 53 34 50 3Z"/>',

    flower:
      '<path d="M50 10V90M15 30L85 70M15 70L85 30" fill="none" stroke="currentColor" stroke-width="14" stroke-linecap="round"/>',

    heart:
      '<path d="M50 89 13 53C-12 25 24-6 50 22C76-6 112 25 87 53Z"/>',

    dot:
      '<circle cx="50" cy="50" r="32"/>',

    diamond:
      '<path d="M50 4 89 50 50 96 11 50Z"/>'
  };

  const symbols = {
    '★': 'star',
    '☀': 'sun',
    '✦': 'sparkle',
    '✻': 'flower',
    '♥': 'heart',
    '●': 'dot',
    '◆': 'diamond'
  };

  const clean = value =>
    (value || '').replace(/[\uFE0E\uFE0F]/g, '').trim();

  function resolve(value) {
    return drawings[value]
      ? value
      : symbols[clean(value)] || '';
  }

  function makeIcon(value) {
    const name = resolve(value);
    if (!name) return null;

    const svg = document.createElementNS(NS, 'svg');

    svg.setAttribute('viewBox', '0 0 100 100');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('fill', 'currentColor');

    svg.innerHTML = drawings[name];

    svg.style.cssText =
      'display:block;width:100%;height:100%;overflow:visible';

    return svg;
  }

  const modulo = (value, length) =>
    ((value % length) + length) % length;

  class PathText {
    constructor({
      path,
      layer,
      measure,
      phrase,
      separator,
      gap = 28,
      maxRepeats = 4,
      closed = true
    }) {
      this.path = path;
      this.layer = layer;
      this.measure = measure;
      this.closed = closed;
      this.length = path.getTotalLength();
      this.items = [];

      this.sampleCount = Math.max(
        360,
        Math.min(2048, Math.ceil(this.length / 2))
      );

      this.samples = Array.from(
        { length: this.sampleCount + 1 },
        (_, index) =>
          path.getPointAtLength(
            this.length * index / this.sampleCount
          )
      );

      layer.replaceChildren();

      phrase = (phrase || '').trim();
      if (!phrase || !this.length) return;

      const style = getComputedStyle(measure);
      const fontSize = parseFloat(style.fontSize) || 24;
      const chars = Array.from(phrase);

      const widths = chars.map(char => {
        measure.textContent = char === ' ' ? '\u00A0' : char;

        return Math.max(
          0,
          measure.getComputedTextLength()
        ) || fontSize * .3;
      });

      measure.textContent = phrase;

      const box = measure.getBBox();
      const centreY = box.y + box.height / 2;

      const rawWidth = widths.reduce(
        (sum, width) => sum + width,
        0
      );

      const icon = makeIcon(separator);
      const custom = icon ? '' : (separator || '').trim();

      let iconSize = icon ? fontSize : 0;

      if (custom) {
        measure.textContent = custom;
        iconSize = measure.getComputedTextLength() || fontSize;
      }

      const minGap = Math.max(10, gap);

      const minUnit = rawWidth + (
        iconSize
          ? iconSize + minGap * 2
          : minGap
      );

      const repeatCount = closed
        ? Math.max(
            1,
            Math.min(
              maxRepeats,
              Math.floor(this.length / minUnit)
            )
          )
        : Math.ceil(this.length / minUnit) + 2;

      this.period = closed
        ? this.length / repeatCount
        : minUnit;

      const available = this.period - (
        iconSize
          ? iconSize + minGap * 2
          : minGap
      );

      const shrink = Math.min(
        1,
        Math.max(.05, available / rawWidth)
      );

      const phraseWidth = rawWidth * shrink;

      for (let repeat = 0; repeat < repeatCount; repeat++) {
        const start = repeat * this.period;
        let cursor = 0;

        chars.forEach((char, index) => {
          const advance = widths[index] * shrink;

          if (char.trim()) {
            const group = document.createElementNS(NS, 'g');
            const text = document.createElementNS(NS, 'text');

            text.setAttribute(
              'class',
              measure.getAttribute('class') || ''
            );

            text.classList.remove('bbf-measure');
            text.style.visibility = 'visible';
            text.style.fontSize = `${fontSize * shrink}px`;

            text.setAttribute('x', String(-advance / 2));
            text.setAttribute('y', String(-centreY * shrink));
            text.textContent = char;

            group.append(text);
            layer.append(group);

            this.items.push({
              node: group,
              distance: start + cursor + advance / 2
            });
          }

          cursor += advance;
        });

        if (iconSize) {
          const group = document.createElementNS(NS, 'g');

          if (icon) {
            const drawing = icon.cloneNode(true);

            drawing.setAttribute('x', String(-iconSize / 2));
            drawing.setAttribute('y', String(-iconSize / 2));
            drawing.setAttribute('width', String(iconSize));
            drawing.setAttribute('height', String(iconSize));

            drawing.style.width = `${iconSize}px`;
            drawing.style.height = `${iconSize}px`;

            group.append(drawing);
          } else {
            const text = document.createElementNS(NS, 'text');

            text.setAttribute(
              'class',
              measure.getAttribute('class') || ''
            );

            text.classList.remove('bbf-measure');
            text.style.visibility = 'visible';

            text.setAttribute('text-anchor', 'middle');
            text.setAttribute('dominant-baseline', 'central');
            text.textContent = custom;

            group.append(text);
          }

          layer.append(group);

          this.items.push({
            node: group,
            distance:
              start + (phraseWidth + this.period) / 2
          });
        }
      }

      measure.textContent = '';
      this.paint(0);
    }

    point(distance) {
      const value = this.closed
        ? modulo(distance, this.length)
        : Math.max(0, Math.min(this.length, distance));

      const position =
        value / this.length * this.sampleCount;

      const index = Math.min(
        this.sampleCount - 1,
        Math.floor(position)
      );

      const fraction = position - index;
      const a = this.samples[index];
      const b = this.samples[index + 1];

      return {
        x: a.x + (b.x - a.x) * fraction,
        y: a.y + (b.y - a.y) * fraction
      };
    }

    paint(offset) {
      this.items.forEach(item => {
        let distance = item.distance + offset;

        if (this.closed) {
          distance = modulo(distance, this.length);
        } else {
          distance =
            item.distance +
            modulo(offset, this.period) -
            this.period;

          item.node.style.display =
            distance < 0 || distance > this.length
              ? 'none'
              : '';

          if (distance < 0 || distance > this.length) return;
        }

        const p = this.point(distance);
        const before = this.point(distance - .5);
        const after = this.point(distance + .5);

        const angle = Math.atan2(
          after.y - before.y,
          after.x - before.x
        ) * 180 / Math.PI;

        item.node.setAttribute(
          'transform',
          `translate(${p.x} ${p.y}) rotate(${angle})`
        );
      });
    }
  }

  function fixSimpleIcons() {
    document.querySelectorAll('.bhmn-separator').forEach(span => {
      if (span.querySelector('svg')) return;

      const icon = makeIcon(span.textContent);
      if (!icon) return;

      span.style.width = 'var(--mn-icon-size)';
      span.style.height = 'var(--mn-icon-size)';
      span.replaceChildren(icon);
    });

    document.querySelectorAll('.bd-separator svg text').forEach(text => {
      const icon = makeIcon(text.textContent);

      if (icon) {
        text.closest('svg').replaceWith(icon);
      }
    });
  }

  function fixWave(wave) {
    const path = wave.querySelector('defs path');
    const original = wave.querySelector('.wave-banner__text');

    if (!path || !path.getAttribute('d') || !original) return;

    const message = wave.querySelector(
      '.wave-banner__accessible-text'
    )?.textContent.trim();

    if (!message) return;

    const style = getComputedStyle(original);

    const signature = [
      path.getAttribute('d'),
      message,
      wave.dataset.separator,
      style.font,
      style.letterSpacing
    ].join('|');

    if (wave.bhIconSignature === signature) return;

    wave.bhIconSignature = signature;
    original.style.visibility = 'hidden';

    let layer = wave.querySelector('[data-bh-wave-layer]');
    let measure = wave.querySelector('[data-bh-wave-measure]');

    if (!layer) {
      layer = document.createElementNS(NS, 'g');
      layer.setAttribute('data-bh-wave-layer', '');

      wave.querySelector('svg').append(layer);

      measure = document.createElementNS(NS, 'text');
      measure.setAttribute('data-bh-wave-measure', '');

      wave.querySelector('svg').append(measure);
    }

    for (const node of [measure, layer]) {
      node.style.fontFamily = style.fontFamily;
      node.style.fontSize = style.fontSize;
      node.style.fontWeight = style.fontWeight;
      node.style.fontStyle = style.fontStyle;
      node.style.letterSpacing = style.letterSpacing;
      node.style.fill = style.fill;
      node.style.color = style.fill;
    }

    measure.style.visibility = 'hidden';

    const engine = new PathText({
      path,
      layer,
      measure,
      phrase: message,
      separator: wave.dataset.separator,
      gap: Math.max(12, parseFloat(style.fontSize)),
      closed: false
    });

    wave.bhIconEngine = engine;

    if (!wave.bhIconScroll) {
      wave.bhIconScroll = () => {
        if (!wave.isConnected || !wave.bhIconEngine) return;

        const reduced = matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        const offset = reduced
          ? 0
          : window.scrollY *
            (Number(wave.dataset.speed) / 100) *
            (wave.dataset.direction === 'right' ? 1 : -1);

        wave.bhIconEngine.paint(offset);
      };
    }

    wave.bhIconScroll();
  }

  function scan() {
    fixSimpleIcons();

    document
      .querySelectorAll('floating-wave-banner')
      .forEach(fixWave);
  }

  let scanFrame = null;

  function scheduleScan() {
    if (scanFrame !== null) return;

    scanFrame = requestAnimationFrame(() => {
      scanFrame = null;
      scan();
    });
  }

  let scrollFrame = null;

  window.addEventListener('scroll', () => {
    if (scrollFrame !== null) return;

    scrollFrame = requestAnimationFrame(() => {
      scrollFrame = null;

      document
        .querySelectorAll('floating-wave-banner')
        .forEach(wave => wave.bhIconScroll?.());
    });
  }, { passive: true });

  window.addEventListener('resize', scheduleScan, {
    passive: true
  });

  window.BHDecorations = {
    PathText,
    makeIcon
  };

  document.dispatchEvent(new Event('bh:decorations-ready'));

  function boot() {
    scan();

    new MutationObserver(scheduleScan).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['d']
    });

    document.fonts?.ready.then(() => {
      document
        .querySelectorAll('floating-wave-banner')
        .forEach(wave => {
          wave.bhIconSignature = '';
        });

      scheduleScan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {
      once: true
    });
  } else {
    boot();
  }
})();